
export class Font {
    
    public name?: string;
    
    public size?: number;
    
    public italic?: boolean;
    
    public bold?: boolean;

    public color?: string;
}